// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserBanned-userBannedContainer-Lntrg {
	margin: 90px auto 50px;
	padding-left: 20px;
	padding-right: 20px;
	max-width: var(--max-content-width);
	min-height: 430px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.UserBanned-textCenter-axRVz {
	text-align: center;
}

.UserBanned-userBannedHeading-gpTIp {
	font-size: 95px;
	line-height: normal;
	font-weight: bold;
	margin: 0;
}

.UserBanned-contactLink-kXSdi,
.UserBanned-contactLink-kXSdi:hover {
	color: var(--primary-link-foreground);
}

.UserBanned-subText-fvZE2 {
	font-size: 22px;
	font-weight: 400;
	line-height: normal;
	margin-top: 20px;
	color: var(--secondary-foreground);
}

@media (max-width:991px) {
	.UserBanned-userBannedHeading-gpTIp {
		font-size: 50px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/userbanned/UserBanned.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,mCAAmC;CACnC,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,SAAS;AACV;;AAEA;;CAEC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".userBannedContainer {\n\tmargin: 90px auto 50px;\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n\tmax-width: var(--max-content-width);\n\tmin-height: 430px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.userBannedHeading {\n\tfont-size: 95px;\n\tline-height: normal;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.contactLink,\n.contactLink:hover {\n\tcolor: var(--primary-link-foreground);\n}\n\n.subText {\n\tfont-size: 22px;\n\tfont-weight: 400;\n\tline-height: normal;\n\tmargin-top: 20px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width:991px) {\n\t.userBannedHeading {\n\t\tfont-size: 50px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userBannedContainer": `UserBanned-userBannedContainer-Lntrg`,
	"textCenter": `UserBanned-textCenter-axRVz`,
	"userBannedHeading": `UserBanned-userBannedHeading-gpTIp`,
	"contactLink": `UserBanned-contactLink-kXSdi`,
	"subText": `UserBanned-subText-fvZE2`
};
module.exports = ___CSS_LOADER_EXPORT___;
